import {makeAutoObservable} from "mobx";

export default class AppStore {
    constructor() {
        this._settings = []
        this._localizationsItems = {
            lang: 'Язык',
            all_news: "Все новости",
            prev_new: "Предыдущая новость",
            next_new: "Следующая новость",
            tags: "Теги",
            no_data: "Страница в разработке...",
            calendar_competions: "Календарь соревнований",
            subscribe_news: "Подписаться на новости",
            subscribe: "Подписаться",
            footer_bottom: "Национальная Федерация Падел Республики Казахстан",
            send: "Отправить",
            latest_news: "Последние новости",
            find: "Найти",
            email: "Почта",
            news_categories: "Категории",
            all: "Все",
            share: "Поделиться",
            main: "Главная",
            search: "Введите слова для поиска...",
            no_padel_centers: "В данном регионе отсутствуют падел-центры",
            centers: "Падель центры",
            map_region_karagandinskaya_oblast: "Карагандинская область",
            map_region_ulytauskaya_oblast: "Область Ұлытау",
            map_region_turkistanskaya_oblast: "Туркестанская область",
            map_region_zhambulskaya_oblast: "Жамбылская область",
            map_region_severno_kazahstanskaya_oblast: "Северо-Казахстанская область",
            map_region_oblast_akmola: "Акмолинская область",
            map_region_mangystauskaya_oblast: "Мангистауская область",
            map_region_atyrauskaya_oblast: "Атырауская область",
            map_region_zapadno_kazahstanskaya_oblast: "Западно-Казахстанская область",
            map_region_aktyubinskaya_oblast: "Актюбинская область",
            map_region_kostanajskaya_oblast: "Костанайская область",
            map_region_kyzylordinskaya_oblast: "Кызылординская область",
            map_region_oblast_zhetisu: "Область Жетісу",
            map_region_almatinskaya_oblast: "Алматинская область",
            map_region_pavlodarskaya_oblast: "Павлодарская область",
            map_region_abajskaya_oblast: "Область Абай",
            map_region_vostochno_kazahstanskaya_oblast: "Восточно-Казахстанская область",
            map_region_shymkent: "Шымкент",
            map_region_almata: "Алматы",
            map_region_astana: "Астана",
            ratings_title: "Рейтинги",

            ratings_men: "Мужчины",
            ratings_women: "Женщины",

            ratings_filter: "Фильтр",

            ratings_month: "Месяц",
            ratings_all_months: "Все месяцы",
            ratings_previous_month: "Предыдущий месяц",
            ratings_next_month: "Следующий месяц",

            ratings_name: "ФИО",
            ratings_country: "Страна",
            ratings_tournaments: "Турниры",
            ratings_points: "Баллы",

            ratings_all: "Все",
            ratings_reset: "Сбросить всё",

            ratings_no_data: "Нет данных",


        }
        this._lang = localStorage.getItem('i18nextLng')
        this._languages = []
        this._userCabinet = true
        this._bonuses = false
        this._minimumOrderAmount = null
        this._registerByPhone = false
        makeAutoObservable(this)
    }

    setRegisterByPhone(registerByPhone) {
        this._registerByPhone = registerByPhone
    }

    setSettings(settings) {
        this._settings = settings
    }

    setLocalizationsItems(localizationsItems) {
        this._localizationsItems = localizationsItems
    }

    setLang(lang) {
        localStorage.setItem('i18nextLng', lang)
        this._lang = lang
    }

    setLanguages(languages) {
        this._languages = languages
    }

    setUserCabinet(userCabinet) {
        this._userCabinet = userCabinet
    }

    setBonuses(bonuses) {
        this._bonuses = bonuses
    }

    setMinimumOrderAmount(minimumOrderAmount) {
        this._minimumOrderAmount = minimumOrderAmount
    }

    get registerByPhone() {
        return this._registerByPhone
    }

    get settings() {
        return this._settings
    }

    get localizationsItems() {
        return this._localizationsItems
    }

    get lang() {
        return this._lang
    }

    get languages() {
        return this._languages
    }

    get userCabinet() {
        return this._userCabinet
    }

    get minimumOrderAmount() {
        return this._minimumOrderAmount
    }
    
    get bonuses() {
        return this._bonuses
    }

}